import { render } from "./SortBlock.vue?vue&type=template&id=3f77fe1f"
import script from "./SortBlock.vue?vue&type=script&lang=js"
export * from "./SortBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__